module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-2000-Classes-Inactive-2b260bbbc7f7836e5e8deed0a5465d33.png";